import { toast } from 'react-toastify';
import api from '../config.js';
import { format } from 'date-fns';
import errorSound from '../assets/error-sound.mp3';
import { IoCheckmarkCircle } from "react-icons/io5";
import { IoMdCloseCircle } from "react-icons/io";
import { MdNotStarted, MdBarcodeReader } from "react-icons/md";
import { GrDeliver } from "react-icons/gr";
import { FaArrowDown, FaArrowUp, FaBoxes, FaCheck, FaPause, FaThumbsDown, FaThumbsUp } from "react-icons/fa";
import { LuClipboardList } from "react-icons/lu";
import { GoChecklist } from "react-icons/go";
import { FaListCheck, FaBoxOpen, FaTruckRampBox, Fa0, FaTruckFast} from "react-icons/fa6";
import { RiCalendarCheckLine } from "react-icons/ri";
import { CiDeliveryTruck } from "react-icons/ci";
import { TbForklift } from "react-icons/tb";
import { FaForward } from "react-icons/fa"; 
import { FaWifi } from "react-icons/fa";

export function changeDisable(option){
  if (option === 'v') {
    return true;
  } else {
    return false;
  }
}

export function objectToURLParams(object){
  const params = new URLSearchParams();
  const copiedObject = {...object};

  for(const propertyName in object){
    let objectValue = (copiedObject[propertyName]?.value);
    let propertyIsObject = (objectValue !== undefined);
    let propertyIsArray = (Array.isArray(copiedObject[propertyName]));

    if(propertyIsArray && copiedObject[propertyName]?.length !== 0){
      let isArrayOfSelectLib = (copiedObject[propertyName][0]?.value !== undefined); 

      params.append(propertyName, copiedObject[propertyName]?.map((objectValue) => (isArrayOfSelectLib ? objectValue.value : objectValue))?.join(", "));
      continue;
    }

    if(propertyIsObject && objectValue !== ""){
      params.append(propertyName, objectValue);
      continue;
    }

    if(copiedObject[propertyName] !== "" && !propertyIsObject){
      params.append(propertyName, copiedObject[propertyName]);
      continue;
    }
  }

  return params.toString();
}

export function convertURLParamsToObject(URLParams){
  const params = new URLSearchParams(URLParams);
  const object = {};

  for(const [key, value] of params){
    if(object[key] === undefined){
      let propertyIsArray = (value?.split(", ")?.length > 1);

      if(propertyIsArray){
        object[key] = value?.split(", ");
      } else{
        object[key] = value;
      }
    }
  }

  return object;
}

export function keepJustValuesInOptionsList(list){
  let newList = [];

  list?.map((item) => {
    newList.push(item.value);
  });

  return newList;
}

export const customModalStylesBase = (widthStyle) => {
  return {
      content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      width: widthStyle,
      maxHeight: '80%',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    }
  }
}

export function createArraysWithColumnsValues(data, columnsListsForFilter, setColumnsListsForFilter){
  for(let i = 0; i < data.length; i++){
      Object.entries(data[i]).map((property) => {
          if(!columnsListsForFilter[property[0]]){
              columnsListsForFilter[property[0]] = [];
          }

          if(!columnsListsForFilter[property[0]]?.some((item) => item?.value?.includes(property[1])) && property[1]){
              columnsListsForFilter[property[0]]?.push({value: property[1], label: property[1]});
          }
      });
  }

  setColumnsListsForFilter(columnsListsForFilter);
}

export function changeCheckboxState(array, index){
  let arrayWithChanges = [];

  array.map((object, objectIndex) => {
    if(objectIndex === index){
      object.isSelected = !object.isSelected;
    }

    arrayWithChanges.push(object);
  });

  return arrayWithChanges;
}

export function getPeople(setPeople) {
  api
    .get("/api/people/getList")
    .then((response) => {
      let people = [];

      response.data.row.map((data) => {
        people.push({label: data.nome_fantasia, value: data.id});
      });
      people.unshift({value: "", label: "Selecione"});

      setPeople(people);
    })
    .catch((error) => {
      console.log(error);
      showMessageError(error?.response?.data);
    });
}

export function removeEmptyValuesOfObject(object){
  Object.entries(object).map((property) => {
    if(object[property[0]]?.length === 0){
      delete object[property[0]];
    }
  });

  return object;
}

export function addFocusToTheElement(element){
  element?.current?.focus();
}

export function getTableElementsWidthByLength(length){
  return `${100 / length}%`;
}

export function convertStringValueToBoolean(value){
  if(value === "true" || value === "S" || value === "Sim"){
    return true;
  }

  if(value === "false" || value === "N" || value === "Não"){
    return false;
  }

  toast.error("O valor inserido não pode ser convertido para o tipo booleano");

  return;
}

export function convertBooleanValueToString(value){
  if(value === true || value === 1){
    return "Sim";
  } else if(value === false || value === 0){
    return "Não";
  }
}

export function calculateColSpan(tableHeaderValues){
  let result = tableHeaderValues.reduce((previousTableHeaderValue, currentTableHeaderValue) => {
    if(currentTableHeaderValue.validation){
      return previousTableHeaderValue?.scope + currentTableHeaderValue?.scope;
    }
  });

  return result;
}

export function getUsers(setUsers, setCarrying){  
  api
  .get(`/api/users/getList`)
  .then((response) => {
    let array = [];

    response.data.map((data) => {
      array.push({label: data.nome, value: data.id})
    });

    setUsers(array);

    setCarrying(false);
  })
  .catch((error) => {
    toast.error('Ops! Ocorreu um erro.');
    setCarrying(false);
  });
}

export function changeValueOfArrayOfObjects(setArray, array, stateName, objectID, value){
  let filteredArray = array.filter((object) => object.id === objectID)[0];
  filteredArray[stateName] = value;

  return setArray(array);
}

export function getDateAndHourByCreatedAt(createdAt){
  const splittedDateAndHour = createdAt.split("T");

  const splittedDate = splittedDateAndHour[0]?.split("-")
  const dateInFinalVersion = `${splittedDate[2]}/${splittedDate[1]}/${splittedDate[0]}`;

  const hourInFinalVersion = splittedDateAndHour[1]?.split(".")[0];

  return {date: dateInFinalVersion, hour: hourInFinalVersion};
}

export function getCurrentArrayOfLocalStorage(arrayOfLocalStorage, arrayOfRequest){
  let itemExists;
  let newArray = [];

  JSON.parse(arrayOfLocalStorage, arrayOfRequest).map((item) => {
    if(parseInt(item?.id) === arrayOfRequest?.id){
        item = arrayOfRequest;

        itemExists = item;
    }

    newArray.push(item);
  });

  return newArray;
}

export function checkIfStringIsFloatAndConvert(value){
  let numberInStringHasComma = value?.split(",");

  if(value === ""){
    return 0.00;
  }
  
  if(numberInStringHasComma.length < 1){
    return parseFloat(value);
  }

  return parseFloat(`${numberInStringHasComma[0]}.${numberInStringHasComma[1]}`);
}

export function checkIfItemExistsInLocalStorage(itemOfLocalStorage, itemOfRequest){
  const localItem = localStorage.getItem(itemOfLocalStorage);
  let newItemValues = [];

  JSON.parse(localItem).map((itemOfLocalStorage) => {
      if(parseInt(itemOfLocalStorage?.id) === parseInt(itemOfRequest?.id)){
          newItemValues.push(itemOfLocalStorage);
      }
  });

  return newItemValues.length !== 0 ? newItemValues : undefined;
}

export function addInLocalStorage(nameOfLocalStorage, itemOfLocalStorage, itemOfRequest){
  const localItem = localStorage.getItem(itemOfLocalStorage);
  let localItemExists = ['undefined', null, ''].includes(localItem);
  let itemExists = checkIfItemExistsInLocalStorage(nameOfLocalStorage, itemOfRequest);

  if(!localItemExists){
      return localStorage.setItem(nameOfLocalStorage, JSON.stringify([itemOfRequest]));
  }

  if(localItemExists && !itemExists){
      return localStorage.setItem(nameOfLocalStorage, JSON.stringify([...itemExists, itemOfRequest]));
  }
}

export function updateInLocalStorage(nameOfLocalStorage, itemOfLocalStorage, itemOfRequest){
  const localItem = localStorage.getItem(itemOfLocalStorage);
  let localItemExists = ['undefined', null, ''].includes(localItem);
  let itemExists = checkIfItemExistsInLocalStorage(nameOfLocalStorage, itemOfRequest);

  if(localItemExists && itemExists){
      localStorage.setItem(nameOfLocalStorage, JSON.stringify(itemExists));
  }
}

export function deleteOrderInLocalStorage(nameOfLocalStorage, arrayOfLocalStorage, localProperty, value){
  let filteredLocalOrder = JSON.parse(arrayOfLocalStorage).filter((localOrder) => parseInt(localOrder[localProperty]) !== parseInt(value));

  return localStorage.setItem(nameOfLocalStorage, JSON.stringify(filteredLocalOrder));
}

export function convertCount(number){
  let param = number.toString();

  if(param.length !== 3){
    for(let i = param.length; i < 3; i++){
      param = `0${param}`;
    }
  }
  
  return param;
}

export function viewItem(list, item, fonte = '') {
  let aux = '';
  list.map((element) => {
    if ((element.id && (element.id == item)) || (element.chave && (element.chave == item))) {
      aux = element.descricao;
      
      if (!aux) {
        aux = element.nome;
      }
    }
  });

  return aux;
}

export function maskSN(item) {
  if (item == 'S') {
    return 'Sim';
  } else {
    return 'Não';
  }
}

export function viewLogOperation(item) {
  switch (item) {
    case 'U':
      return 'Atualização';
      
      break;
      
    case 'I':
      return 'Inserção';
      
      break;
      
    case 'IS':
      return 'Separação';
      
      break;
      
    case 'S':
      return 'Alteração Status';
      
      break;
  
    case 'C':
      return 'Vínculo para Conferência';
      
      break;
      
    case 'F':
      return 'Finalização';
        
    case 'R':
      return 'Liberação de Conferência';
      
      break;
    default:
      break;
  }
}

export function convertDateAndHour(time){
  const dateAndTime = new Date(time);
  const formatedDateAndHour = format(dateAndTime, 'dd/MM/yyyy HH:mm:ss');

  return formatedDateAndHour
}

export function convertDateToBrazilianFormat(time){
  const convertedTime = time.split('-');

  return `${convertedTime[2]}/${convertedTime[1]}/${convertedTime[0]}`;
}

export function convertDateToAmericanFormat(time){
  const convertedTime = time.split('/');

  return `${convertedTime[1]}-${convertedTime[0]}-${convertedTime[2]}`;
}

export function activeMask(item) {
  let aux = 'Não';
  if (item == 'S') {
    aux = 'Sim';
  }

  return aux;
}

export function removeDuplicateValuesInArray(array, property){
  let verifiedArray = [];
  let thisPropertyExists;

  array?.map((object) => {
    thisPropertyExists = object[property];

    if(object[property] && !verifiedArray.includes(object[property])){
      verifiedArray.push(object);
    }

    if(!verifiedArray.includes(object)){
      verifiedArray.push(object);
    }

    return object;
  });

  return verifiedArray;
}

export function handleInput(setState, event, inputType){
  let { name, value } = event.target;

  if(inputType === "number"){
    value = parseInt(value);
  }

  if(inputType === "boolean"){
    value = convertStringValueToBoolean(value);
  }

  setState((prevState) => ({...prevState, [name]: value}));
}

export function viewItemProduct(list, item, fonte = '') {
  let aux = '';
  list.map((element) => {
    if (element.id == item || element.id_produto === item) {
      aux = element["codigo_produto" || "id_produto"] + ' - ' + element.descricao;
    }
  });

  return aux;
}

export function validateDate(date) {
  if(!date)
    return '';
    const RegExPattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
  
  if (date.match(RegExPattern)) {
    return date;
  } else {
    toast.error('Data inválida.');
    return '';
  }
}

export function getGeneric(table) {
  api.get("/api/generics/getItens?table=" + table.toUpperCase())
  .then((response) => {
    return response.data;
  }).catch((error) => {
    toast.error('Ops! Ocorreu um erro.');
  });
}

export function sortArray(arr, index, order = 'asc') {
  arr.sort(function(a, b) {
    var keyA = a[index],
        keyB = b[index];
    
    if (order == 'asc') {
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
    } else {
      if (keyA < keyB) return 1;
      if (keyA > keyB) return -1;    
    }
    return 0;
  });
  return arr;
}

export function getClients(peopleSearchValue, setClients, setCarrying) {
  if(peopleSearchValue === "Selecione"){
    peopleSearchValue = "";
  }

  api
  .get(`/api/people/getList?search=${peopleSearchValue}`)
  .then((response) => {
    let adaptedValuesToSelectLib = [];

    response.data.row.map((client, index) => {
      if(adaptedValuesToSelectLib?.length <= 50){
        adaptedValuesToSelectLib.push({label: client.nome_fantasia, value: client.id});
      }
    });

    adaptedValuesToSelectLib.unshift({value: "", label: "Selecione"});

    setClients(adaptedValuesToSelectLib);
  })
  .catch((error) => {
      console.log(error);
      showMessageError(error?.response?.data);
  })
  .finally(() => {
      setCarrying(false);
  });
}

export function getProducts(productSearchValue, setProducts, setCarrying){
  if(productSearchValue === "Selecione"){
    productSearchValue = "";
  }

  api
  .get(`/api/products/getSearchProduct?term=${productSearchValue}`)
  .then((response) => {
      let adaptedValuesToSelectLib = [];

      response.data.list.map((product, index) => {
          if(adaptedValuesToSelectLib?.length <= 50){
              adaptedValuesToSelectLib.push({ label: `${product.codigo_produto} - ${product.descricao}`, value: product.id});
          }
      });

      adaptedValuesToSelectLib.unshift({value: "", label: "Selecione"});

      setProducts(adaptedValuesToSelectLib);
  })
  .catch((error) => {
      if(error?.response?.data){
          showMessageError(error?.response?.data);
      }

      console.log(error);
  })
  .finally(() => {
      setCarrying(false);
  });
}

export function getWarehouses(warehouseSearchValue, setWarehouses, setCarrying){
  if(warehouseSearchValue === "Selecione"){
    warehouseSearchValue = "";
  }

  api
  .get(`/api/warehouses/getSearchWarehouses?term=${warehouseSearchValue}`)
  .then((response) => {
    let adaptedValuesToSelectLib = [];

    response.data.list.map((warehouse, index) => {
        if(adaptedValuesToSelectLib?.length <= 50){
          adaptedValuesToSelectLib.push({label: warehouse.descricao, value: warehouse.id});
        }
    });

    adaptedValuesToSelectLib.unshift({value: "", label: "Selecione"});

    setWarehouses(adaptedValuesToSelectLib);
  })
  .catch((error) => {
    showMessageError(error.response.data);
  })
  .finally(() => {
    setCarrying(false);
  });
}

export function getPermission(module) {
  let aux = false;

  if (localStorage.SistemUser) {
    let data = JSON.parse(localStorage.SistemUser);
    if (data.permissoes && data.permissoes.length > 0) {
      data.permissoes.forEach(element => {
        if (element.nome == module) {
          aux = true;
        }
      });    
    }
  }
  
  return aux;
}

export function eraseBarOfGenericMask(newValue){
  if(newValue.length === 6){
    newValue.slice(0, 5);
  }

  if(newValue.length === 3){
    newValue.slice(0, 2);
  }

  return newValue;
}

export function newSetMaskGeneric(value){
  console.log(value)
  const newValue = value.replace(/\D/g, '');

  let maskedValue = '';
  if (newValue.length >= 2) {
    maskedValue += `${newValue.substr(0, 2)}/`;
  }
  if (newValue.length >= 4) {
    maskedValue += `${newValue.substr(2, 2)}/`;
  }
  if (newValue.length > 4) {
    maskedValue += newValue.substr(4, 4);
  }

  return maskedValue;
};

export function setMaskGeneric(value, Mask) {
  if (value === ""){
    return '';
  }

  if (['(',')',',','.','@',' ','-'].indexOf(value.slice(-1)) > -1){
    return value.substring(0,value.length -1);
  }
 
  if (Mask && Mask !== '') {
    let evento = '';
    let boleanoMask;
    let Digitato = evento.keyCode;
    let exp = /-|\.|\/|\(|\)| /g;
    let campoSoNumeros = value ? value.toString().replace( exp, "" ) : '';
    let posicaoCampo = 0;
    let NovoValorCampo="";
    let TamanhoMask = campoSoNumeros.length;

    if (Digitato !== 8) { // backspace
      for(let i=0;i<= TamanhoMask;i++) {
        boleanoMask  = ((Mask.charAt(i) === "-") || (Mask.charAt(i) === ".")
                                                || (Mask.charAt(i) === "/"))
        boleanoMask  = boleanoMask || ((Mask.charAt(i) === "(")
                                                || (Mask.charAt(i) === ")") || (Mask.charAt(i) === " "))
        if (boleanoMask) {
          NovoValorCampo += Mask.charAt(i);
          TamanhoMask++;
        }else {
          NovoValorCampo += campoSoNumeros.charAt(posicaoCampo);
          posicaoCampo++;
        }
      }
      
      return NovoValorCampo;
    } else {
      return value;
    }
  } else {
    return value;
  }
}

export function setMaskHour(value, Mask) {
  if ([':'].indexOf(value.slice(-1)) > -1){
    return value.substring(0,value.length -1);
  }
  
  var hora01 = '';
  hora01 = hora01 + value;
  
  if (hora01.length == 2) {
    value = hora01 + ':';
  } 

  if (hora01.length == 5) {
    value = hora01 + ':';
  }
  return value;
}

export function validateEmail(email){
  if (email != '') {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  } else {
    return true;
  }
}

export function setMaskDecimal(value, precision){
  if(value) {
    let count = 0;
    for (let index = 0;index < value.length;index++) {
      const element = value[index];
      if (element == ',') {
        count++;
      }
    }

    if (count < 2) {
      if ((value.length == 2) && (value.substring(0,value.length -1) == '0') && (value != '0,')){
        return '';
      } else {  
        if ([',','1','2','3','4','5','6','7','8','9','0'].indexOf(value.slice(-1)) > -1){
          return value;
        } else {
          return value.substring(0, value.length -1);
        }
      }
    } else {
      return value.substring(0, value.length -1);
    }
  }
}

export function setMaskDecimalDefaul(value, precision){
  if(value) {
    let v = value.replace(/\D/g,'');
        v = (v/Math.pow(10,precision)).toFixed(precision) + '';
        v = v.replace(".", ",");
        v = v.replace(/(\d)(\d{3})(\d{3})(\d{3}),/g, "$1.$2.$3.$4,");
        v = v.replace(/(\d)(\d{3})(\d{3}),/g, "$1.$2.$3,");
        v = v.replace(/(\d)(\d{3}),/g, "$1.$2,");
    return v;
  }
}

export function validatePassword(senha, confirmacao){
  var passo1 = senha;

  // verifica se tem ao menos uma letra maiúscula
  if(senha.match(/[A-Z]{1,}/)){
     passo1 = true;
  }else{
     passo1 = false;
  }

  const regex = /\W|_/;

  if(regex.test(senha) && senha == confirmacao && passo1 && senha.length > 7){
    return true;
  } else if (senha !== confirmacao){
    return "Senhas não conferem!";
  } else {
    return "A senha precisa ter pelo menos 8 caracteres, caracteres especiais, letra maiúscula e minúscula e números.";
  }
}

export function dateToday(){
  var data = new Date();
  var dia = data.getDate();
  if (dia.toString().length == 1) {
    dia = "0" + dia;
  }
  var mes = data.getMonth() + 1;
  if (mes.toString().length == 1) {
    mes = "0" + mes;
  }
  var ano = data.getFullYear();

  return dia + "/" + mes + "/" + ano;
}

export function hoursNow(){
  var dataAtual = new Date();

  var horas = dataAtual.getHours();
  var minutos = dataAtual.getMinutes();
  var segundos = dataAtual.getSeconds();

  if (horas.toString().length == 1) {
    horas = "0" + horas;
  }

  if (minutos.toString().length == 1) {
    minutos = "0" + minutos;
  }

  if (segundos.toString().length == 1) {
    segundos = "0" + segundos;
  }

  return horas + ':' + minutos + ':' + segundos;
}

export function parseToFloat(value) {
  if (value && value != '') {
    value = value.replace('.','').replace(',','.');
    
    value = parseFloat(value);
    
    value = value.toFixed(2);
    
    return parseFloat(value);
  } else {
    return 0;
  }
}

export function makeSearch(list, fields, term) {
  term = term.toUpperCase();
  let item = null;
  let new_list = [];

  list.map((element, k) => {
    item = null;

    fields.map((field) => {
      if (element[field] && element[field]?.toUpperCase() && element[field]?.toUpperCase()?.includes(term)) {
        item = element;
      }
    });
    if (item) {
      new_list.push(item);
    }
  });

  return new_list;
}

export function releaseAddress(){
  api.get("/api/release_adresses")
  .then((response) => {
    
  }).catch((error) => {
    
  });
}

export function getParameter(name) {
  let data = JSON.parse(localStorage.SistemUser);
  if(localStorage.getItem('empresa')!==null){
    let empresa = data.empresas.filter((obj) => obj.id == localStorage.empresa);
  
    if (empresa[0]?.parametros) {
      let aux = empresa[0]?.parametros.filter((obj) => obj.nome == name);
      if (aux[0]?.valor) 
        return aux[0].valor;
    }
  }

}

export function getListFromFlow(fluxo, listStatus) {
  let aux_fluxo = fluxo?.split(',');
  let aux = listStatus?.filter((obj) => aux_fluxo?.indexOf(obj.chave) >= 0);
  return aux;
}

export function checkWhichIconMustToBeReturned(currentStatus, size){
  if(currentStatus === "APROVADO"){
    return <IoCheckmarkCircle style={{color: "#4ED54E", fontSize: size}} />
  }

  if(currentStatus === "EM CONFERENCIA"){
    return <MdBarcodeReader style={{color: "#FFD70E", fontSize: size}} />
  }

  if(currentStatus === "LANÇADO"){
    return <LuClipboardList style={{color: "#B9B9B9", fontSize: size}} />
  }

  if(currentStatus === "CONFERIDO"){
    return <RiCalendarCheckLine style={{color: "#B9B9B9", fontSize: size}} />
  }

  if(currentStatus === "ENDERECANDO"){
    return <TbForklift style={{color: "#FFD70E", fontSize: size}} />
  }

  if(currentStatus === "FINALIZADO"){
    return <FaListCheck style={{color: "#4ED54E", fontSize: size}} />
  }

  if(currentStatus === "NEGADO"){
    return <IoMdCloseCircle style={{color: "#D63737", fontSize: size}} />
  }

  if(currentStatus === "INICIADO"){
    return <MdNotStarted style={{color: "#FBB221", fontSize: size}} />
  }

  if(currentStatus === "ENTREGUE"){
    return <FaBoxOpen style={{color: "#D89929", fontSize: size}} />
  }

  if(currentStatus === "SOLICITADO"){
    return <GoChecklist style={{color: "#B9B9B9", fontSize: size}} />
  }

  if(currentStatus === "SEPARADO"){
    return <FaBoxes style={{color: "#D89929", fontSize: size}} />
  }

  if(currentStatus === "PAUSADO"){
    return <FaPause style={{color: "#FFD70E", fontSize: size}} />
  }

  if(currentStatus === "EM EXPEDICAO"){
    return <FaTruckFast style={{color: "#B9B9B9", fontSize: size}} />
  }

  if(currentStatus === "EXPEDIDO"){
    return <CiDeliveryTruck style={{color: "#B9B9B9", fontSize: size}} />
  }

  if(currentStatus === "EM SEPARACAO"){
    return <FaTruckRampBox style={{color: "#D89929", fontSize: size}} />
  }

  if(currentStatus === "EM ANDAMENTO"){
    return <FaForward style={{color: "#FFD70E", fontSize: size}} />
  }

  if(currentStatus === "INTEGRAÇÃO PENDENTE"){
    return <FaWifi style={{color: "#FBB221", fontSize: size}} />
  }

  if(currentStatus === "LIBERADO P/ CONFERENCIA"){
    return <FaThumbsUp style={{color: "#FBB221", fontSize: size}} />
  }
}

export function validateType(value, type, listTipos){
  let item = {};
  let retorno = false;
  let aux = '';

  listTipos.map((element) => {
    if (element.chave == type) {
      item = element;
    }
  });

  if (item.descricao == "Decimal") {
    aux = parseFloat(value);
    
    if (aux) {
      retorno = true;
    }
  }

  if (item.descricao == "Inteiro") {
    aux = parseInt(value);
    
    if (aux) {
      retorno = true;
    }
  }

  if (item.descricao == "Booleano") {
    let aliasBool = ['T', 'F', 'TRUE', 'FALSE', 'VERDADEIRO', 'FALSO'];
    
    if (aliasBool.indexOf(value.toUpperCase()) > -1) {
      retorno = true;
    } 
  }

  if (item.descricao == "Texto") {
    aux = toString(value);
    
    if (aux) {
      retorno = true;
    }
  }

  if (item.descricao == "JSon") {
    try {
      aux = JSON.parse(value);
      retorno = true;
    } catch (e) {
      
    }
  }

  if (item.descricao == "E-mail") {
    if (validateEmail(value)) {
      retorno = true;
    }
  }

  return retorno;
}

export function getMaxValue (rows, field) {
  let aux = 1;
  
  rows.map((element) => {
    if (element[field] != '' && parseInt(element[field])) {
      aux += 1;
    }
  });
  
  return aux;
}

export function removeItemArray (array, index) {
  let aux = [];
  array.filter((element, i) => {
    if (i !== index)
      aux.push(element);
  });
  
  return aux;
}

export function custom(width, height){
  return {
      content:{
          position: 'fixed',
          top: '50%',
          left: '50%',
          right: 'auto',
          width: width,
          height: height,
          maxHeight: '80%',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 100,
          border: "1px solid rgb(204, 204, 204)",
          backgroundColor: "white"
      }
  }
}

export function beep() {
  const audio = new Audio(errorSound);
  audio.play();
}

export const customShortModal = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    width: '500px',
    maxHeight: '80%',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

export const customHalfModal = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    maxHeight: '80%',
    width: '900px',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

export const customFullModal = {
  content: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    width: '80%',
    maxHeight: '80%',
    height: 'auto',
    backgroundColor: "white",
    transform: 'translate(-50%, -50%)',
  },
};

export const customAdaptativeModal = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    width: '80%',
    maxHeight: '80%',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

export function isEqual(a, b) {
  var aProps = Object.getOwnPropertyNames(a);
  var bProps = Object.getOwnPropertyNames(b);

  if (aProps.length != bProps.length) {
      return false;
  }

  for (var i = 0; i < aProps.length; i++) {
      var propName = aProps[i];
      if (a[propName] !== b[propName]) {
          return false;
      }
  }

  return true;
}

export function formatDecimal(value) {
  return value.toString().replace('.',',');
}

export function checkIfArrayAlreadyWasListed(array, setArray, getArray){
  const arrayAlreadyWasListed = array.length !== 0;

  if(arrayAlreadyWasListed){
    return setArray([]);
  }

  return getArray();
}

export function changeCursorExhibition(ref, newCursorType){
  ref.current.style.cursor = newCursorType;
}

export function showMessageError(object) {
  if (object?.message) {
    toast.error(object.message);
  } else if (object.error?.message) {
    toast.error(object.error.message);
  } else {
    toast.error('Ops! Ocorreu um erro.');
  }
}

export function showIconDivergence(value_control, value) {
  value_control = parseToFloat(value_control);
  value = parseToFloat(value);
  
  if (value == value_control) {
    return <FaCheck color="#009900" size={17}/>
  } else if (value > value_control) {
    return <FaArrowDown color="#FF0000" size={17}/>
  } else {
    return <FaArrowUp color="#FF0000" size={17}/>
  }
}

export function showDecimalMark(value) {
  if (!value || value == '') {
    return '0';
  }
  return value.toString().replace('.', ',');
}

export function getLabels(list) {
  var labels = [];
  var indexs = [];
  
  Object.getOwnPropertyNames(list[0]).filter(element => {
    if (element != 'ID') {
      labels.push(element.replaceAll( '_', " "));
      indexs.push(element);
    }
  });
  
  return [labels, indexs];
}